// src/plugins/filebrowser.js
import Noty from 'noty'
import i18n from '../i18n'
import { disableExternal } from '../../lib/filebrowser/src/utils/constants'

export default {
  install(app) {
    const notyDefault = {
      type: 'info',
      layout: 'bottomRight',
      timeout: 1000,
      progressBar: true
    }

    app.config.globalProperties.$noty = (opts) => {
      new Noty(Object.assign({}, notyDefault, opts)).show()
    }
    app.config.globalProperties.$showSuccess = (message) => {
      new Noty(Object.assign({}, notyDefault, {
        text: message,
        type: 'success'
      })).show()
    }
    app.config.globalProperties.$showError = (error) => {
      const btns = [
        Noty.button(i18n.t('buttons.close'), '', (n) => n.close())
      ]
      if (!disableExternal) {
        btns.unshift(
          Noty.button(i18n.t('buttons.reportIssue'), '', () => {
            window.open('https://github.com/filebrowser/filebrowser/issues/new/choose')
          })
        )
      }
      new Noty(Object.assign({}, notyDefault, {
        text: error.message || error,
        type: 'error',
        timeout: null,
        buttons: btns
      })).show()
    }

    app.directive('focus', {
      mounted(el) {
        el.focus()
      }
    })
  }
}
